module.exports = __webpack_public_path__ + "img/it.e01d3a93.png";